/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFolderOpen = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M2 22V2h8.618l2 3H20v4h2.166l-3.308 13zm17.834-11H6.858l-2.692 9h12.976zM9.382 4H4v9.725L5.142 9H18V7h-6.618z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgFolderOpen as FolderOpen };
